module.exports = __webpack_public_path__ + "static/img/why-3-3.f4157d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/why-3-3.png
// module id = CYss
// module chunks = 1